(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ms-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wrapAccent(root) {
      if (!root) return;
      var title = root.querySelector(".ms-ingredients__title");
      if (!title) return;
      if (title.querySelector(".ms-ingredients__title-accent")) return;
    }

    function initForAllSections() {
      var sections = document.querySelectorAll(".ms-ingredients");
      if (!sections.length) return;
      sections.forEach(function (root) {
        wrapAccent(root);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initForAllSections);
    } else {
      initForAllSections();
    }

    document.addEventListener("shopify:section:load", function (event) {
      var sectionEl = event.target;
      if (!sectionEl || !sectionEl.classList.contains("ms-ingredients")) return;
      wrapAccent(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-tab-problemsolution"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      var buttons = section.querySelectorAll('.ms-tabs-ps__btn');
      var panels = section.querySelectorAll('.ms-tabs-ps__panel');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = btn.dataset.tab;

          buttons.forEach(function (b) {
            b.classList.remove('ms-tabs-ps__btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('ms-tabs-ps__panel--active');
          });

          btn.classList.add('ms-tabs-ps__btn--active');
          btn.setAttribute('aria-selected', 'true');
          var target = section.querySelector('.ms-tabs-ps__panel[data-tab="' + index + '"]');
          if (target) target.classList.add('ms-tabs-ps__panel--active');
        });
      });
    }

    function init() {
      document.querySelectorAll('.ms-tabs-ps').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.ms-tabs-ps');
      if (el) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-timeline"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var timelines = document.querySelectorAll('.ms-timeline');
    if (!timelines.length) return;

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    timelines.forEach(function(root){
      var stage = root.querySelector('[data_glw_stage]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data_glw_item]'));
      if (!stage || !items.length) return;

      var smoothFill = 0;
      var ticking = false;

      function computeTargets() {
        var stageRect = stage.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        var startY = vh * 0.35;
        var endY = vh * 0.55;
        var progressRaw = (startY - stageRect.top) / Math.max(1, (stageRect.height - (endY - startY)));
        var progress = clamp(progressRaw, 0, 1);

        var dotPositions = [];
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          var dotY = (r.top - stageRect.top) + 14;
          dotPositions.push(clamp(dotY, 0, stageRect.height));
        }

        dotPositions.sort(function(a, b){ return a - b; });

        var targetFill = progress * stageRect.height;
        targetFill = clamp(targetFill, 0, stageRect.height);

        var activeCount = 0;
        for (var j = 0; j < dotPositions.length; j++) {
          if (targetFill >= dotPositions[j] - 2) {
            activeCount++;
          }
        }

        return {
          targetFill: targetFill,
          activeCount: activeCount
        };
      }

      function applyState(state) {
        smoothFill = lerp(smoothFill, state.targetFill, 0.18);
        if (Math.abs(smoothFill - state.targetFill) < 0.6) {
          smoothFill = state.targetFill;
        }

        stage.style.setProperty('--fill_px', smoothFill.toFixed(2) + 'px');

        for (var i = 0; i < items.length; i++) {
          if (i < state.activeCount) {
            items[i].classList.add('is_active');
          } else {
            items[i].classList.remove('is_active');
          }
        }
      }

      function tick() {
        ticking = false;
        var state = computeTargets();
        applyState(state);

        if (Math.abs(smoothFill - state.targetFill) > 0.8) {
          requestAnimationFrame(tick);
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(tick);
      }

      smoothFill = 0;
      onScroll();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
